import { render, staticRenderFns } from "./BankListDeposit.vue?vue&type=template&id=9db1e066&lang=pug"
import script from "./BankListDeposit.vue?vue&type=script&lang=js"
export * from "./BankListDeposit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports